import React from 'react';
import { baseReducer } from '../reducers/baseReducer';
import { beforeMiddlewares, afterMiddlewares } from '../middleware';
import { useReducerWithMiddleware } from '../utils/storeUtils';
import { Store } from '../utils/storeContext';

interface StoreProviderProps<T> {
  children: React.ReactNode;
  initialState: T;
  reducer?: (state: T, action: any) => T;
  before?: any[];
  after?: any[];
}

export function StoreProvider<T = StoreState>({
  children,
  initialState,
  reducer = baseReducer as unknown as (state: T, action: any) => T,
  before = beforeMiddlewares,
  after = afterMiddlewares,
}: StoreProviderProps<T>) {
  const [storeState, dispatch] = useReducerWithMiddleware<T>(reducer, initialState, before, after);

  return <Store.Provider value={{ storeState, dispatch } as any}>{children}</Store.Provider>;
}
